export default {
  companyStructureMetadata: {
    fixateChangesButton: 'Зафиксировать изменения',
    fixateChangesCaption: 'Последние изменения не зафиксированы',
    noTeamGroups: 'Нет подразделений',
    newTeamGroupName: 'Новое подразделение',
    createTeamGroupButton: 'Добавить подразделение',
    stubTitle: 'Выберите<br/>подразделение',
    stubText: 'Чтобы настроить его параметры',
    divisionSettings: 'Настройка подразделения',
    name: 'Название',
    parent: 'Родительское подразделение',
    description: 'Описание',
    supervisors: 'Руководители',
    teams: 'Команды',
    enterName: 'Введите название',
    shortDescription: 'Краткое описание подразделения',
    createDivisions: 'Создать новое подразделение?',
    createButton: 'Да, создать',
    deleteDivision: 'Удалить подразделение?',
    successMessages: {
      changeAllTeamGroup: 'Подразделение успешно изменено',
      createTeamGroup: 'Подразделение успешно создано',
      deleteTeamGroup: 'Подразделение успешно удалено',
    },
    errorMessages: {
      changeAllTeamGroup: 'Не удалось изменить подразделение',
      createTeamGroup: 'Не удалось создать подразделение',
      deleteTeamGroup: 'Не удалось удалить подразделение',
    },
  },
};
